import './style.scss';

export default function Dashboard() {
  return <div className="new_dashboard">dashboard coming soon...</div>;
}
